import gql from 'graphql-tag';
import { useCallback, useContext } from 'react';
import { useMutation } from 'react-apollo';
import { LoginMutation, LoginMutationVariables } from './__generated__/LoginMutation';
import { AuthContext } from '../AuthService';

const LOGIN = gql`
  mutation LoginMutation($token: String!) {
    login(token: $token)
  }
`;

type LoginFunction = (token: string) => Promise<void>;

export const useLogin = (): [LoginFunction, { loading: boolean; error: Error | undefined }] => {
  const [loginMutation, { loading, error }] = useMutation<LoginMutation, LoginMutationVariables>(LOGIN);
  const auth = useContext(AuthContext);

  const login: LoginFunction = useCallback(
    async (token: string) => {
      await loginMutation({
        variables: {
          token,
        },
      });
      auth.setAccessToken(token);
    },
    [loginMutation, auth]
  );

  return [login, { loading, error }];
};
